<template>
    <section>
        <sui-segment basic>
            <h2 is="sui-header" floated="right" color="grey">
                <sui-icon name="file alternate"/>
                <sui-header-content>Reporte de incidencias RUG</sui-header-content>
            </h2>
            <br>
        </sui-segment>
        <sui-segment basic class="mb-0 pb-0">
            <sui-form v-on:submit.prevent>
                <sui-form-fields fields="four">
                    <sui-form-field>
                        <label>R.F.C. o Nombre de la empresa</label>
                        <input type="text" v-model="searchRecord.coincidir"/>
                    </sui-form-field>
                    <sui-form-field>
                        <label>Estatus</label>
                        <sui-dropdown
                            multiple
                            :options="Utils.displayOptionsFromArray(RugGuaranteeToBluStatusList, 'value', 'text')"
                            placeholder="Estatus"
                            selection
                            v-model="searchRecord.status"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <label>Tipo Garantia</label>
                        <sui-dropdown
                            multiple
                            :options="Utils.displayOptions(RugGuaranteesStatus)"
                            placeholder="Tipo Garantia"
                            selection
                            v-model="searchRecord.rugStatus"
                        />
                    </sui-form-field>
                    <sui-form-field>
                        <br>
                        <sui-button primary icon="search" @click="saveFilters(); loadRecords()">Buscar</sui-button>
                        <sui-button secondary icon="cancel" @click="restoreRecords(); saveFilters()">Limpiar</sui-button>
                    </sui-form-field>
                </sui-form-fields>
            </sui-form>
        </sui-segment>

        <div style="max-width: 100%; max-height:60vh; overflow-x: scroll;">
            <GenericPaginatedList
                @navigate="emittedNavigation"
                :color="'blue'"
                :recordName="recordName"
                :headers="headers"
                :callback="loadRecords"
                :navigate="{ value: false, blank: false }"/>
        </div>
    </section>
</template>

<script>

import GenericPaginatedList from '@/components/Generic/PaginatedList.vue'
import Mixins from '@/mixins/index.js'
import RugGuaranteeToBluStatus from '@/common/RugGuaranteeToBluStatus'
import RugGuaranteesStatus from '@/common/RugGuaranteesStatus'
import RugService from '@/services/RugService'
import Utils from '@/common/Utils.js'

export default {
    name: 'RugGuaranteeToBluList',
    components: { GenericPaginatedList },
    mixins: [ Mixins ],

    data () {
        return {
            apiEndpoint: '/relations',
            recordService: RugService,
            recordName: 'rugGuaranteeToBlu',
            records: [],
            record: { clientId: 0 },
            total: 0,
            products: [],
            totalProducts: 0,
            selectAllProducts: false,
            searchRecord: {
                page: 1,
                folio: '',
                pageSize: 35,
                order: 'DESC',
                status: [],
                rugStatus: []
            },
            headers: [
                {
                    name: 'Garantia',
                    type: 'object',
                    key: 'rugGuarantee',
                    value: 'guaranteeNumber',
                    width: 4,
                    navigate: {
                        value: true,
                        blank: true
                    }
                },
                { name: 'Acreedor', type: 'object', key: 'rugCreditor', value: 'officialName', width: 4 },
                { name: 'cliente', type: 'object', key: 'client', value: 'entityName', width: 3 },
                {
                    name: 'RFC cliente',
                    type: 'object',
                    key: 'client',
                    value: 'rfc',
                    width: 4,
                    navigate: {
                        value: true,
                        customName: 'client',
                        emits: true
                    }
                },
                {
                    name: 'Credito',
                    type: 'object',
                    key: 'credit',
                    value: 'folio',
                    width: 3,
                    navigate: {
                        value: true,
                        customName: 'credit',
                        emits: true
                    }
                },
                { name: 'Fecha', value: 'createdAt', type: 'date', align: 'center', width: 1 },
                { name: 'Estatus', value: 'status', options: this.RugGuaranteeToBluStatusTranslated, type: 'renderOption', width: 1 },
                { name: 'Tipo garantia', value: 'rugStatus', options: this.RugGuaranteesStatus, type: 'renderOption', width: 1 }
            ],
            RugGuaranteeToBluStatus,
            RugGuaranteesStatus
        }
    },

    async beforeMount () {
        if (!this.$store.getters.isLoggedIn) window.location.replace('/logout')
    },

    async mounted () {
        if (this.$store.getters.filters[this.recordName] && Object.keys(this.$store.getters.filters[this.recordName]).length) {
            this.searchRecord = Object.assign({}, this.$store.getters.filters[this.recordName])
        }

        await this.loadRecords(1, this.apiEndpoint, 'records', 'total', this.searchRecord)
        let header = this.headers.find(item => item.value === 'status')
        if (header) { header.options = this.RugGuaranteeToBluStatusTranslated }
        header = this.headers.find(item => item.value === 'rugStatus')
        if (header) { header.options = this.RugGuaranteesStatus }
    },

    methods: {
        saveFilters () {
            const data = Object.assign({}, this.searchRecord)
            this.$store.dispatch('setFilters', { recordName: this.recordName, data })
        },
        emittedNavigation (item, navigation) {
            if (navigation.customName === 'client') {
                this.record = item
                return this.goToExternalLink(this.clientDetailUrl)
            }

            if (navigation.customName === 'credit') {
                this.record = item
                return this.goToExternalLink(this.creditDetailUrl)
            }
        }
    },
    computed: {
        RugGuaranteeToBluStatusList () {
            const RugGuaranteeToBluStatusList = []
            for (const status in this.RugGuaranteeToBluStatus) {
                RugGuaranteeToBluStatusList.push({
                    status,
                    text: (Utils.getRugGuaranteeTobluStatusInfo(RugGuaranteeToBluStatus[status])).name || status,
                    value: RugGuaranteeToBluStatus[status]
                })
            }
            return RugGuaranteeToBluStatusList
        },
        RugGuaranteeToBluStatusTranslated () {
            const RugGuaranteeToBluStatusTranslated = {}
            for (const status in this.RugGuaranteeToBluStatus) {
                const translation = (Utils.getRugGuaranteeTobluStatusInfo(RugGuaranteeToBluStatus[status])).name || status
                RugGuaranteeToBluStatusTranslated[translation] = this.RugGuaranteeToBluStatus[status]
            }
            return RugGuaranteeToBluStatusTranslated
        }
    }
}
</script>
<style scoped>
    .ui.table thead tr:first-child > th {
         position: sticky !important;
         top: 0;
         z-index: 2;
    }
</style>
